<template>
  <AppModalDialog hash="sign-up">
    <Contact v-if="step === 'contact'" :form-state @next="onContactNext" />
    <Verify
      v-else-if="step === 'verify'"
      :email="formState.email"
      :is-existing-user="formState.isExistingUser"
      @success="onSuccess"
      @needsName="step = 'name'"
      @back="step = 'contact'"
    />
    <Name v-else :form-state @success="onSuccess" />
  </AppModalDialog>
</template>

<script setup>
import {reactive, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import AppModalDialog from "@/components/App/Modal/Dialog/index";
import Contact from "@/components/App/Modal/SignIn/Contact";
import Verify from "@/components/App/Modal/SignIn/Verify";
import Name from "@/components/App/Modal/SignIn/Name";

const route = useRoute();
const router = useRouter();
const step = ref("contact");
const formState = reactive({email: "", firstName: "", lastName: "", isExistingUser: false});

watch(
  () => route.hash,
  (hash) => {
    if (hash !== "#sign-up") {
      step.value = "contact";
      Object.assign(formState, {email: "", firstName: "", lastName: "", isExistingUser: false});
    }
  },
);

function onContactNext(isExistingUser) {
  formState.isExistingUser = isExistingUser;
  step.value = "verify";
}

function onSuccess() {
  router.replace({path: route.path, hash: ""});
}
</script>
